import { render, staticRenderFns } from "./ProjektDeckblatt.vue?vue&type=template&id=07e9b0be&"
import script from "./ProjektDeckblatt.vue?vue&type=script&lang=js&"
export * from "./ProjektDeckblatt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports